import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import swal from 'sweetalert'
import DatePicker from 'react-datetime';
import ls from 'local-storage'
import 'react-datetime/css/react-datetime.css';

export class Technicalsanction extends Component {
    constructor(props){     
        super(props);
        this.state = {
            errors: {},
            details:[],  
            tsstatuslist:[],
            appstatuslist:[],
            partworktsforwad:[],
            partworktsapproval:[],            
            TSForwardedHideShow: false,          
            TSApprovedshowHide: false,
            savefile:{},
            formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode},
                       
        };
        this.hideComponent = this.hideComponent.bind(this);
        this.hideComponentfile = this.hideComponentfile.bind(this);
        this.selecthandleChange = this.selecthandleChange.bind(this);
        this.datepickerhandleChange = this.datepickerhandleChange.bind(this);
        this.getdataafterload = this.getdataafterload.bind(this); 
      }
      componentDidMount() {
        document.title = "Technical Sanction"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        this.getdataafterload();
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;        
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/getaastatus`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.aastatuscd,
              "label" : d.aastatusdesc          
            }))    
            this.setState({tsstatuslist: options})  
          }           
        });   
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/getappstatus`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.aastatuscd,
              "label" : d.aastatusdesc          
            }))    
            this.setState({appstatuslist: options})  
          }           
        });                       
      }
      async getdataafterload()
      {
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;           
        Axios.post(`${process.env.REACT_APP_API_URL}partworks/technicalsection`, this.props.children)
        .then(result=>{
          if(result.status === 200){
            this.setState({partworktsapproval:result.data.partworktsapproval});                      
            this.setState({partworktsforwad:result.data.partworktsforwad});                    
          }      
        }); 
      }
      hideComponent(e) { 
        let formdetails = this.state.formdetails;
        formdetails[e.target.name] = e.target.value;  
        this.setState({formdetails});          
        if(e.target.name === 'tsstatus'){ 
        switch (e.target.value) {
            case '1':
              this.setState({ TSForwardedHideShow:true,TSApprovedshowHide:false });
              break;
            case '2':
              this.setState({ TSApprovedshowHide:true,TSForwardedHideShow:false });
              break;
            default:
                this.setState({ TSApprovedshowHide:false,TSForwardedHideShow:false });
          }  
        }
    }
    hideComponentfile(e) { 
      let savefile = this.state.savefile;  
      let formdetails = this.state.formdetails; 
      formdetails[e.target.name] = e.target.value;      
      savefile = e.target.files[0];  
      this.setState({savefile,formdetails});          
    }    
    handleValidation(){
        let formdetails = this.state.formdetails;        
        let errors = {};
        let formIsValid = true;
        
        //By
        if(!formdetails["tsstatus"]){
          formIsValid = false;
          errors["tsstatus"] = "Select By";
        }
  
        if(typeof formdetails["tsstatus"] !== "undefined"){
          if(!formdetails["tsstatus"].match(/^[0-9]+$/)){
            formIsValid = false;
            errors["tsstatus"] = "Only Number";
          }      	
        } 
        //For
        if(!formdetails["tslno"]){
            formIsValid = false;
            errors["tslno"] = "For";
          } 
        // Forwarded Data      
        if(formdetails["tsstatus"] === '1'){
            if(!formdetails["tsforwardedto"]){
                formIsValid = false;
                errors["tsforwardedto"] = "Select Forwarded to";
              }
              if(!formdetails["tsfordate"]){
                formIsValid = false;
                errors["tsfordate"] = "Enter Date of Forwarding";
              }              
              if(!formdetails["tsremarks"]){
                formIsValid = false;
                errors["tsremarks"] = "Enter Remarks";
              }              
        }   
        // Approved Data   
        if(formdetails["tsstatus"] === '2'){
          if(!formdetails["bappstatus"]){
            formIsValid = false;
            errors["bappstatus"] = "Select Approved By";
          }            
          if(!formdetails["letterno"]){
            formIsValid = false;
            errors["letterno"] = "Enter TS No";
          }            
          if(!formdetails["tsamount"]){
            formIsValid = false;
            errors["tsamount"] = "Enter TS Amount (Net)";
          }            
          if(!formdetails["tsamountg"]){
            formIsValid = false;
            errors["tsamountg"] = "Enter TS Amount (Gross)";
          }            
          if(!formdetails["tsdate"]){
            formIsValid = false;
            errors["tsdate"] = "Enter TS Date";
          }            
        }      
        this.setState({errors: errors});
        return formIsValid;
      } 
      async refreshvalue(){ 
        this.setState({formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode}}); 
      }   
      contactSubmit(e){
        e.preventDefault();        
        if(this.handleValidation()){    
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;         
          const data = this.state.formdetails;
          const formData = new FormData();               
          formData.append('data', JSON.stringify(data));
          if(data["tsstatus"] === '2'){
          formData.append("apppdf", this.state.savefile);  
          }
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/savetechnicalsanction`, formData) 
            .then((responce) => { 
              const result = responce.data;
              if(result.status === 1){    
                this.getdataafterload();    
                this.refreshvalue();    
                swal({
                  title: result.msg,
                  text: "Data Save Successfully",
                  icon: "success",
                  buttons: true
                })             
            }
            else{
              if(result.status === 401){
              swal("Error", result.message, "error"); 
              }else{
                swal("Error", result.msg, "error"); 
              }              
            }              
            });
        }   
      }         
    async selecthandleChange(name,e) {
        let formdetails = this.state.formdetails; 
        formdetails[name] = e.value;  
        this.setState({formdetails});        
      }  
      datepickerhandleChange(name,e){
        let formdetails = this.state.formdetails;
        formdetails[name] = e.format('DD-MM-YYYY');
        this.setState({formdetails});
      }   
      async TSApprovedDelete(slno,id){    
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const formdetails =  this.state.formdetails;
          formdetails['slno'] = slno;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deletetsapprovedtable`, formdetails) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "TS Approved Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });          
      }       
      async TSForwardeDeleted(slno,id){    
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const formdetails =  this.state.formdetails;
          formdetails['slno'] = slno;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deletetsforwaredtable`, formdetails) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "TS Forwared Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });          
      }   
    render() {
        const { TSForwardedHideShow, TSApprovedshowHide } = this.state;
        return (
                    <div className="box">
                    <div className="box-body">
                        <h4>Technical Sanction</h4>
                        <form  onSubmit= {this.contactSubmit.bind(this)} >
                            <div className="col-md-12" >
                                <div className="col-md-4" >
                                <div className="form-group">
                                    <label>By</label>
                                    <select name="tsstatus" value={this.state.formdetails.tsstatus  || ''}  className="form-control" onChange={this.hideComponent}>
                                        <option value="">Select Revised TS</option>
                                        <option value="1">Forwarded</option>
                                        <option value="2">Approved</option>
                                    </select>
                                    <span className="text-red">{this.state.errors["tsstatus"]}</span>
                                </div>
                                </div>
                                <div className="col-md-4" >
                                <div className="form-group">
                                    <label>T.S No</label>
                                    <select name="tslno" value={this.state.formdetails.tslno  || ''} className="form-control" onChange={this.hideComponent}>
                                        <option value="">Select T.S No</option>
                                        <option value="1">T.S</option>
                                        <option value="2">Revised T.S</option>
                                    </select>
                                    <span className="text-red">{this.state.errors["tslno"]}</span>
                                </div>
                                </div>
                            </div>
                            { TSForwardedHideShow && (
                            <div className="col-md-12">
                                <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Forwarded to</label>
                                    <Select 
                                            options={this.state.tsstatuslist} 
                                            name="tsforwardedto" 
                                            value={this.state.tsstatuslist.filter(({value}) => value === this.state.formdetails.tsforwardedto)  || ''} 
                                            isClearable
                                            onChange={this.selecthandleChange.bind(this,'tsforwardedto')} 
                                    />
                                    <span className="text-red">{this.state.errors["tsforwardedto"]}</span>
                                </div>
                                </div>
                                <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Date of Forwarding</label>
                                    <DatePicker 
                                        timeFormat={false}
                                        onChange={this.datepickerhandleChange.bind(this,'tsfordate')}
                                        dateFormat="DD-MM-YYYY" 
                                        value={this.state.formdetails.tsfordate || ''}
                                        closeOnSelect 
                                    /> 
                                    <span className="text-red">{this.state.errors["tsfordate"]}</span>
                                </div>
                                </div>
                                <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Remarks</label>
                                    <textarea name="tsremarks" value={this.state.formdetails.tsremarks  || ''} rows="2" className="form-control" onChange={this.hideComponent} />
                                    <span className="text-red">{this.state.errors["tsremarks"]}</span>
                                </div>
                                </div>
                            </div>
                            )}
                            { TSApprovedshowHide && (
                            <div>
                                <div className="col-md-12">
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Approved By</label>
                                        <Select 
                                                options={this.state.appstatuslist} 
                                                name="bappstatus" 
                                                value={this.state.appstatuslist.filter(({value}) => value === this.state.formdetails.bappstatus)  || ''} 
                                                isClearable
                                                onChange={this.selecthandleChange.bind(this,'bappstatus')} 
                                        /> 
                                        <span className="text-red">{this.state.errors["bappstatus"]}</span>                                       
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">TS Date / Sanctioned Date</label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'tsdate')}
                                            dateFormat="DD-MM-YYYY" 
                                            value={this.state.formdetails.tsdate || ''}
                                            closeOnSelect 
                                        /> 
                                         <span className="text-red">{this.state.errors["tsdate"]}</span>          
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">TS Amount / Sanctioned Amount (Net)</label>
                                        <input type="text" name="tsamount" className="form-control text-right" value={this.state.formdetails.tsamount  || ''}  onChange={this.hideComponent} />
                                        <span className="text-red">{this.state.errors["tsamount"]}</span>      
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-12">
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">TS Amount / Sanctioned Amount (Gross)</label>
                                        <input type="text" name="tsamountg" className="form-control text-right" value={this.state.formdetails.tsamountg  || ''}  onChange={this.hideComponent} />
                                        <span className="text-red">{this.state.errors["tsamountg"]}</span>   
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Letter No.</label>
                                        <input type="text" name="letterno" className="form-control" value={this.state.formdetails.letterno  || ''}  onChange={this.hideComponent} />
                                        <span className="text-red">{this.state.errors["letterno"]}</span> 
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Upload PDF</label>
                                        <input type="file" name="apppdf" value={this.state.formdetails.apppdf  || ''} onChange={this.hideComponentfile} />
                                    </div>
                                </div>
                                </div>
                            </div>
                            )}
                            <div className="col-md-12" >
                                <div className="col-md-6" >
                                <input type="submit" className="btn btn-primary" value="Save" />
                                </div>
                            </div>
                        </form>
                        <h5 className="text-center"> List TS Approved</h5>
                        <div className="col-md-12">
                            <table className="table table-bordered">
                                <thead>
                                <tr className="bg-gray">
                                    <th>For</th>
                                    <th>Approved By</th>
                                    <th>TS Date</th>
                                    <th>TS Amount(Net)</th>
                                    <th>TS Amount(Gross)</th>
                                    <th>Letter No</th>
                                    <th>Approval  File</th>
                                    <th>Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                        {this.state.partworktsapproval.map((value, index) => {
                                            return (
                                                <tr key={value.slno}>
                                                    <td>{value.slno_name}</td>
                                                    <td>{value.aastatusdesc}</td>
                                                    <td>{value.tsdate}</td>
                                                    <td>{value.tsamount}</td>
                                                    <td>{value.tsamountg}</td>
                                                    <td>{value.tsletterno}</td>
                                                    <td>{value.approvalfile}</td>
                                                    <td><button onClick={this.TSApprovedDelete.bind(this,value.slno)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                                </tr>
                                            )
                                        })} 
                                        </tbody>                                
                            </table>
                        </div>
                        <h5 className="text-center"> List TS Forwarded</h5>
                        <div className="col-md-12" >
                            <table className="table table-bordered">
                                <thead>
                                <tr className="bg-gray">
                                    <th>TS/Revised TS</th>
                                    <th>Forwarded to</th>
                                    <th>Date of Forwarding</th>
                                    <th>Remarks</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                        {this.state.partworktsforwad.map((value, index) => {
                                            return (
                                                <tr key={value.slno}>
                                                    <td>{value.slno_name}</td>
                                                    <td>{value.aastatusdesc}</td>
                                                    <td>{value.tsdate}</td>
                                                    <td>{value.forwardedremark}</td>
                                                    <td><button onClick={this.TSForwardeDeleted.bind(this,value.slno)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                                </tr>
                                            )
                                        })} 
                                        </tbody>                                 
                            </table>
                        </div>
                    </div>
                    </div>
        )
    }
}

export default Technicalsanction
